import React from "react";
import { Button, Col, Form, Row, Badge } from "react-bootstrap";
import Footer from "../components/Footer";
import Comming from "../assets/comming.png";

const Careers = () => {
  return (
    <>
      <Row className="mx-0 stud-test py-3">
        <Col className="text-center">
          <img src={Comming} alt="" className="img-fluid" />
        </Col>
      </Row>
      <Footer />
    </>
  );
};

export default Careers;
